import { ConditionCode } from '@/shared/api/protocol-ts/model/dto_report_condition_codes_pb';

// Tooth-like objects are delivered with numbering only — the annotator does not
// evaluate their presence, so no confidence percent is required. Pontic is the
// exception in FDA 2.0: annotators must enter confidence for Pontic tooth type.
const NO_USER_SCORE_CODES_2D: ConditionCode[] = [
  ConditionCode.CodeTooth,
  ConditionCode.Implant,
  ConditionCode.Missing,
  ConditionCode.RootFragment,
  ConditionCode.ToothGerm,
];

const NO_USER_SCORE_CODES_3D: ConditionCode[] = [
  ...NO_USER_SCORE_CODES_2D,
  ConditionCode.Pontic,
];

type ShouldConditionRequireUserScoreProps = {
  code: ConditionCode;
  is2DReport: boolean;
};

export const shouldConditionRequireUserScore = ({
  code,
  is2DReport,
}: ShouldConditionRequireUserScoreProps) => {
  const noUserScoreCodes = is2DReport
    ? NO_USER_SCORE_CODES_2D
    : NO_USER_SCORE_CODES_3D;

  return !noUserScoreCodes.includes(code);
};
